import service from '@/utils/https';

export const fetchMissionList = (params, config = {}) =>
  service.get('/api/app/v1/missions', {
    params,
    ...config,
  });

// hideMessageModal: la fiche mission affiche son propre écran d'erreur traduit.
// Sans ça, l'intercepteur double l'écran d'un toast portant le message brut de
// l'API, en anglais (« Forbidden: You can only access missions from your team »).
export const fetchMissionDetail = (missionId) =>
  service.get(`/api/app/v1/missions/${missionId}/detail`, { hideMessageModal: true });

export const fetchMissionEnvelopeUsage = (missionId, params = {}) =>
  service.get(`/api/app/v1/missions/${missionId}/envelope-usage`, { params });

export const fetchMissionFreelancers = () => service.get('/api/app/v1/missions/freelancers/options');

export const fetchMissionTeamMembers = () => service.get('/api/app/v1/missions/team-members/options');

export const fetchMissionLocationSuggestions = (params, config = {}) =>
  service.get('/api/app/v1/missions/locations/suggestions', {
    params,
    ...config,
  });

export const createMissionApi = (data, config) => service.post('/api/app/v1/missions', data, config || {});

export const updateMissionApi = (missionId, data) => service.put(`/api/app/v1/missions/${missionId}`, data);

/** PATCH : champs entreprise après signature (nom, bon de commande, code projet / création code). */
export const patchMissionEnterpriseFieldsApi = (missionId, data) =>
  service.patch(`/api/app/v1/missions/${missionId}`, data);

export const assignFreelancerApi = (missionId, freelancerId) =>
  service.post(`/api/app/v1/missions/${missionId}/assign-freelancer`, {
    freelancer_id: freelancerId,
  });

export const deleteMissionApi = (missionId) => service.delete(`/api/app/v1/missions/${missionId}`);

export const uploadMissionDocumentsApi = (missionId, data) => service.post(`/api/app/v1/missions/${missionId}/documents`, data);

export const fetchMissionTemplatePreviewApi = (missionId, data) => service.post(`/api/app/v1/missions/${missionId}/template-variables`, data);

// Téléverser d'autres documents (other-documents)
export const uploadOtherDocumentsApi = (missionId, data) => service.post(`/api/app/v1/missions/${missionId}/other-documents`, data);

// Éditer les documents de mission (mettre à jour les documents existants)
export const editMissionDocumentsApi = (missionId, data) => service.put(`/api/app/v1/missions/${missionId}/documents`, data);

// Supprimer un document
export const deleteDocumentApi = (missionId, documentId) => service.delete(`/api/app/v1/missions/${missionId}/documents/${documentId}`);

// Créer un document de prolongation (contient new_end_date, team_signer_id et informations de fichier)
// Format du corps de la requête :
// {
//   "new_end_date": "2025-12-20T00:00:00.000Z",
//   "team_signer_id": 123,
//   "file_name": "Addendum.pdf",
//   "file_key": "supabase-file-key",
//   "file_url": "supabase-file-url"
// }
export const extendMissionApi = (missionId, data) => service.post(`/api/app/v1/missions/${missionId}/extension-document`, data);

// Terminer la mission de manière anticipée (contient reason et new_end_date)
// Format du corps de la requête :
// {
//   "reason": "Project requirements changed",  // Raison de la résiliation (optionnel)
//   "new_end_date": "2025-11-19T10:12:00.000Z"  // Horodatage actuel au format ISO 8601 UTC
// }
export const terminateMissionApi = (missionId, data) => service.post(`/api/app/v1/missions/${missionId}/terminate`, data);

export const patchScheduledTerminationApi = (missionId, data) =>
  service.patch(`/api/app/v1/missions/${missionId}/scheduled-termination`, data);

export const reviewMissionApprovalApi = (missionId, data) =>
  service.post(`/api/app/v1/missions/${missionId}/approval-review`, data);

// Freelancer accepte la mission
export const acceptMissionApi = (missionId) => service.post(`/api/app/v1/missions/${missionId}/accept`);

// Freelancer refuse la mission (contient reason)
// Format du corps de la requête :
// {
//   "reason": "Reason for rejecting the mission"
// }
export const rejectMissionApi = (missionId, data) => service.post(`/api/app/v1/missions/${missionId}/reject`, data);

// Entreprise annule la mission (avant signature freelance) - pas de body
export const cancelMissionApi = (missionId) => service.post(`/api/app/v1/missions/${missionId}/cancel`);

// Freelancer accepte/refuse un addendum
// Format du corps de la requête :
// {
//   "action": "accept" | "reject",
//   "reason": "Reason for rejecting" (si reject)
// }
export const acceptAddendumApi = (missionId, addendumId, data) => service.post(`/api/app/v1/missions/${missionId}/addenda/${addendumId}/accept`, data);
export const rejectAddendumApi = (missionId, addendumId, data) => service.post(`/api/app/v1/missions/${missionId}/addenda/${addendumId}/reject`, data);
export const cancelAddendumApi = (missionId, addendumId, data) =>
  service.post(`/api/app/v1/missions/${missionId}/addenda/${addendumId}/cancel`, data);

// Get freelancer master agreement
export const fetchFreelancerMasterAgreement = (freelancerId) => service.get(`/api/app/v1/freelancers/${freelancerId}/master-agreement`);

// Initier une signature YouSign (toasts gérés dans MissionDocumentsCard selon data.reason)
export const initiateSignatureRequestApi = (data) =>
  service.post('/api/app/v1/signature-requests/initiate', data, { hideMessageModal: true });

// Refuser un document ou contrat cadre
export const rejectSignableApi = (data) => service.post('/api/app/v1/signature-requests/reject', data);

export default {
  fetchMissionList,
  fetchMissionDetail,
  fetchMissionFreelancers,
  fetchMissionTeamMembers,
  createMissionApi,
  updateMissionApi,
  patchMissionEnterpriseFieldsApi,
  assignFreelancerApi,
  deleteMissionApi,
  uploadMissionDocumentsApi,
  fetchMissionTemplatePreviewApi,
  uploadOtherDocumentsApi,
  editMissionDocumentsApi,
  deleteDocumentApi,
  extendMissionApi,
  terminateMissionApi,
  acceptMissionApi,
  rejectMissionApi,
  reviewMissionApprovalApi,
  cancelMissionApi,
  acceptAddendumApi,
  rejectAddendumApi,
  cancelAddendumApi,
  fetchFreelancerMasterAgreement,
  initiateSignatureRequestApi,
  rejectSignableApi,
};
